/**
 * Known partner still hosts (ledger → direct PNG/JPEG thumbs).
 * Kept in aggregator so Bazaar + Canopy share one source of truth.
 */
import { encodeExtTokenIdentifierSync } from "./extToken.js";
import { tryDecodeExtTokenIndex } from "./tokenId.js";
export const AGGREGATOR_PARTNER_THUMBS = [
    {
        ledgerId: "ghxmp-xiaaa-aaaao-ba4sq-cai",
        imageAssetCanisterId: "gawk3-2qaaa-aaaao-ba4sa-cai",
        imagePathTemplate: "/images/nft_{id}.png",
    },
];
/** Bazaar frontend — static Enchanted Bonsai launch mirrors. */
export const ENCHANTED_BONSAI_LEDGER_ID = "yy7m6-daaaa-aaaag-qciqa-cai";
export const BAZAAR_FRONTEND_ORIGIN = "https://iabi6-zqaaa-aaaau-agwpq-cai.icp0.io";
export const ENCHANTED_BONSAI_COLLECTION_BANNER = `${BAZAAR_FRONTEND_ORIGIN}/collection-art/enchanted-bonsai-banner.gif`;
/** Inclusive — tokens with Bazaar /collection-art/enchanted-bonsai/{i}/ mirrors. */
export const ENCHANTED_BONSAI_LOCAL_MIRROR_MAX_INDEX = 61;
function enchantedBonsaiTokenIndex(ledgerId, tokenId) {
    if (typeof tokenId === "number" && Number.isFinite(tokenId)) {
        return Math.floor(tokenId);
    }
    if (typeof tokenId === "bigint") {
        const n = Number(tokenId);
        return Number.isFinite(n) ? n : null;
    }
    return tryDecodeExtTokenIndex(ledgerId, String(tokenId).trim());
}
export function partnerThumbUrls(ledgerCanisterId, tokenId) {
    const id = ledgerCanisterId.trim();
    const out = [];
    if (id === ENCHANTED_BONSAI_LEDGER_ID) {
        const idx = enchantedBonsaiTokenIndex(id, tokenId);
        if (idx != null && idx >= 0) {
            if (idx <= ENCHANTED_BONSAI_LOCAL_MIRROR_MAX_INDEX) {
                out.push(`${BAZAAR_FRONTEND_ORIGIN}/collection-art/enchanted-bonsai/${idx}/thumb.jpg`);
                out.push(`${BAZAAR_FRONTEND_ORIGIN}/collection-art/enchanted-bonsai/${idx}/thumb.png`);
            }
            const tid = typeof tokenId === "string" && tokenId.length > 20
                ? tokenId.trim()
                : encodeExtTokenIdentifierSync(id, idx);
            out.push(`https://${id}.raw.icp0.io/?type=thumbnail&tokenid=${tid}`);
            out.push(`https://images.entrepot.app/t/${id}/${tid}`);
        }
        return out;
    }
    const row = AGGREGATOR_PARTNER_THUMBS.find((p) => p.ledgerId === id);
    if (!row)
        return [];
    const path = row.imagePathTemplate.replace("{id}", String(tokenId));
    const normalized = path.startsWith("/") ? path : `/${path}`;
    return [`https://${row.imageAssetCanisterId}.raw.icp0.io${normalized}`];
}
